<template>
    <div class="institutions_table">
        <!-- 搜索框、按钮布局 -->
        <div class="inputCont">
            <el-form
                style="width: 100%"
                class="leader-style-form leader-form-inner-tab-inline"
                :inline="screen"
            >
                <el-form-item label="姓名">
                    <el-input
                        maxlength="20"
                        v-model="searchForm.name"
                    ></el-input>
                </el-form-item>

                <el-form-item label="账号">
                    <el-input
                        maxlength="20"
                        v-model="searchForm.account"
                    ></el-input>
                </el-form-item>

                <el-form-item label="部门">
                    <el-input
                        maxlength="20"
                        v-model="searchForm.unit"
                    ></el-input>
                </el-form-item>
                <div>
                    <el-button
                        @click="getListData"
                        size="small"
                        class="leader-common-button"
                        >查询</el-button
                    >
                    <!-- <button @click="getListData" size="small" class="btn-class">查询</button> -->
                    <el-button
                        class="leader-common-button"
                        @click="addNewOne"
                        size="small"
                        >新增</el-button
                    >
                </div>
            </el-form>
        </div>
        <div class="table-wrap-inner" style="height: calc(100% - 76px - 55px)">
            <el-table
                :data="treeTableJson"
                highlight-current-row
                border
                height="100%"
                class="leader-style-table"
            >
                <el-table-column
                    type="index"
                    width="50"
                    align="center"
                ></el-table-column>
                <el-table-column
                    label="姓名"
                    property="user_name"
                    align="center"
                ></el-table-column>
                <el-table-column
                    label="登录账号"
                    property="login_name"
                    align="center"
                ></el-table-column>
                <el-table-column
                    label="角色"
                    property="role_names"
                    align="center"
                ></el-table-column>
                <el-table-column
                    label="部门"
                    property="unit_name"
                    align="center"
                ></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button
                            @click="editNewOne(scope.row)"
                            type="text"
                            class="leader-button edit-button"
                        >
                            <i class="iconfont iconeditor"></i>
                            <span class="inner-text">修改</span>
                        </el-button>
                        <el-button
                            @click="deleteOne(scope.row)"
                            type="text"
                            class="leader-button del-button"
                        >
                            <i class="iconfont iconashbin"></i>
                            <span class="inner-text">删除</span>
                        </el-button>
                        <el-button
                            @click="resetOne(scope.row)"
                            type="text"
                            class="leader-button check-button"
                        >
                            <i class="iconfont iconreset oper-icon"></i>
                            <span class="inner-text">重置密码</span>
                        </el-button>
                        <el-button
                            @click="disableItem(scope.row)"
                            type="text"
                            class="leader-button green-button"
                        >
                            <i
                                class="iconfont iconqiyong oper-icon"
                                v-if="scope.row.state == 0"
                            ></i>
                            <i
                                class="iconfont iconforbid_icon oper-icon"
                                v-else
                            ></i>
                            <span class="inner-text">{{
                                scope.row.state == 0 ? "启用" : "禁用"
                            }}</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination
                :paginationData="paginationData"
                @paginationDataNew="paginationDataNew"
                v-if="this.paginationData.totalNum"
                class="leader-style-pagination"
            ></pagination>
        </div>
        <!-- 新增弹窗 -->
        <el-dialog
            title="新增用户"
            class="leader-dialog"
            :visible.sync="addshow"
            :close-on-click-modal="false"
            @close="dialogClose('addForm')"
        >
            <el-form
                label-width="150px"
                :model="addForm"
                :rules="addRules"
                ref="addForm"
                class="leader-style-form"
            >
                <el-form-item label="姓名" prop="name">
                    <el-input
                        maxlength="20"
                        v-model="addForm.name"
                        placeholder="请填写用户姓名"
                    ></el-input>
                </el-form-item>
                <el-form-item label="登录账号" prop="login_name">
                    <el-input
                        maxlength="20"
                        v-model="addForm.login_name"
                        placeholder="请填写登录账号"
                    ></el-input>
                </el-form-item>
                <el-form-item label="角色" prop="role_ids">
                    <el-select
                        v-model="addForm.role_ids"
                        style="width: 100%"
                        placeholder="请选择角色"
                        @remove-tag="removeAddTag"
                        multiple
                    >
                        <el-option
                            v-for="item in roleJson"
                            :key="item.role_id"
                            :label="item.role_name"
                            :value="item.role_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="角色类型"
                      prop='user_type'>
          <el-select v-model="addForm.user_type"
                     style="width: 100%;"
                     placeholder="请选择角色类型">
            <el-option v-for="item in typeJson"
                       :key="item.codelist_id"
                       :label="item.code_name"
                       :value="item.code_value">
            </el-option>
          </el-select>
                </el-form-item>-->
                <el-form-item label="机构" prop="unit">
                    <el-input
                        maxlength="20"
                        v-model="addForm.unit"
                        :disabled="true"
                    ></el-input>
                </el-form-item>
                <!-- <el-form-item label="是否展示登录后首页" prop="is_show_logined">
                    <el-select
                        v-model="addForm.is_show_logined"
                        style="width: 100%;"
                        placeholder="请选择"
                        @remove-tag="removeEditTag"
                    >
                        <el-option
                            v-for="item in yesOrNo"
                            :key="item.code_value"
                            :label="item.code_name"
                            :value="item.code_value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否接受报警信息" prop="is_warn_user">
                    <el-select
                        v-model="addForm.is_warn_user"
                        style="width: 100%;"
                        placeholder="请选择"
                        @remove-tag="removeEditTag"
                    >
                        <el-option
                            v-for="item in yesOrNo"
                            :key="item.code_value"
                            :label="item.code_name"
                            :value="item.code_value"
                        ></el-option>
                    </el-select>
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    class="leader-common-button"
                    @click="addshow = false"
                    size="small"
                    >关 闭</el-button
                >
                <el-button
                    class="leader-common-button"
                    type="primary"
                    @click="addcommit"
                    size="small"
                    >保 存</el-button
                >
            </div>
        </el-dialog>
        <!-- ----------------------------------- -->
        <!-- 修改弹窗 -->
        <el-dialog
            title="用户修改"
            class="leader-dialog"
            :visible.sync="editshow"
            :close-on-click-modal="false"
            @close="dialogClose('editForm')"
        >
            <el-form
                label-width="150px"
                :model="editForm"
                :rules="addRules"
                ref="editForm"
                class="leader-style-form"
            >
                <el-form-item label="姓名" prop="name">
                    <el-input
                        maxlength="20"
                        v-model="editForm.name"
                        placeholder="请填写用户姓名"
                    ></el-input>
                </el-form-item>
                <el-form-item label="登录账号" prop="login_name">
                    <el-input
                        maxlength="20"
                        v-model="editForm.login_name"
                        placeholder="请填写登录账号"
                    ></el-input>
                </el-form-item>
                <el-form-item label="角色" prop="role_ids">
                    <el-select
                        v-model="editForm.role_ids"
                        style="width: 100%"
                        placeholder="请选择角色"
                        @remove-tag="removeEditTag"
                        multiple
                    >
                        <el-option
                            v-for="item in roleJson"
                            :key="item.role_id"
                            :label="item.role_name"
                            :value="item.role_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="角色类型"
                      prop='user_type'>
          <el-select v-model="editForm.user_type"
                     style="width: 100%;"
                     placeholder="请选择角色类型">
            <el-option v-for="item in typeJson"
                       :key="item.codelist_id"
                       :label="item.code_name"
                       :value="item.code_value">
            </el-option>
          </el-select>
                </el-form-item>-->
                <el-form-item label="机构" prop="unit">
                    <el-input
                        maxlength="20"
                        v-model="editForm.unit"
                        :disabled="true"
                    ></el-input>
                </el-form-item>
                <!-- <el-form-item label="是否展示登录后首页" prop="is_show_logined">
                    <el-select
                        v-model="editForm.is_show_logined"
                        style="width: 100%;"
                        placeholder="请选择"
                        @remove-tag="removeEditTag"
                    >
                        <el-option
                            v-for="item in yesOrNo"
                            :key="item.code_value"
                            :label="item.code_name"
                            :value="item.code_value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否接受报警信息" prop="is_warn_user">
                    <el-select
                        v-model="editForm.is_warn_user"
                        style="width: 100%;"
                        placeholder="请选择"
                        @remove-tag="removeEditTag"
                    >
                        <el-option
                            v-for="item in yesOrNo"
                            :key="item.code_value"
                            :label="item.code_name"
                            :value="item.code_value"
                        ></el-option>
                    </el-select>
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    class="leader-common-button"
                    @click="editshow = false"
                    size="small"
                    >关 闭</el-button
                >
                <el-button
                    class="leader-common-button"
                    type="primary"
                    @click="editcommit"
                    size="small"
                    >保 存</el-button
                >
            </div>
        </el-dialog>
        <!-- ----------------------------------- -->
        <!-- 重置密码弹窗 -->
        <el-dialog
            title="重置密码"
            :visible.sync="resetshow"
            class="leader-dialog"
            :close-on-click-modal="false"
        >
            <el-form
                label-width="100px"
                :model="resetForm"
                :rules="resetRules"
                class="leader-style-form"
                ref="resetForm"
            >
                <el-form-item label="新密码" prop="password">
                    <el-input
                        maxlength="20"
                        v-model="resetForm.password"
                    ></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="passwordAgain">
                    <el-input
                        maxlength="20"
                        v-model="resetForm.passwordAgain"
                    ></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button
                    class="leader-common-button"
                    @click="resetshow = false"
                    size="small"
                    plain
                    >取 消</el-button
                >
                <el-button
                    class="leader-common-button"
                    type="primary"
                    @click="resetPass"
                    size="small"
                    >确 定</el-button
                >
            </div>
        </el-dialog>
        <!-- ------------------------------ -->
    </div>
</template>
<script>
const yesOrNo = [
    {
        code_name: "是",
        code_value: "1"
    },
    {
        code_name: "否",
        code_value: "0"
    }
];
import * as api from "@/http/api.js";
import Bus from "./bus.js";
import pagination from "@/comon/components/pagination.vue";
export default {
    components: {
        pagination
    },
    data() {
        return {
            yesOrNo,
            flag: true,
            searchForm: {
                name: "",
                account: "",
                unit: ""
            },
            paginationData: {
                pageNum: "1",
                pageSize: "10",
                totalNum: ""
            },
            treeTableJson: [],
            tableId: "",
            tableName: "",
            roleJson: [],
            typeJson: [],
            addshow: false,
            addForm: {
                name: "",
                login_name: "",
                role_ids: [],
                // user_type: '',
                unit: "",
                is_show_logined: "0",
                is_warn_user: "0"
            },
            roleString: "",
            addRules: {
                name: [
                    {
                        required: true,
                        message: "请填写用户姓名",
                        trigger: "blur"
                    }
                ],
                login_name: [
                    {
                        required: true,
                        message: "请填写登录账号",
                        trigger: "blur"
                    }
                ],
                role_ids: [
                    {
                        required: true,
                        message: "请填写选择角色",
                        trigger: "change,blur"
                    }
                ],
                // user_type: [
                //     { required: true, message: '请填写选择角色类型', trigger: 'change,blur' }
                // ],
                unit: [
                    { required: true, message: "请选择机构", trigger: "blur" }
                ]
            },

            editshow: false,
            editForm: {
                name: "",
                login_name: "",
                role_ids: [],
                unit: "",
                // user_type: '',
                user_id: "",
                is_show_logined: "",
                is_warn_user: ""
            },
            resetshow: false,
            resetForm: {
                password: "",
                passwordAgain: "",
                user_id: ""
            },
            resetRules: {
                password: [
                    {
                        required: true,
                        message: "请输入新密码",
                        trigger: "blur"
                    }
                ],
                passwordAgain: [
                    {
                        required: true,
                        message: "请确认新密码",
                        trigger: "blur"
                    }
                ]
            },

            disableForm: {
                msg: "",
                user_id: "",
                state: ""
            },
            screenWidth: "",
            screen: true
        };
    },
    methods: {
        //通过unitid获取table主表
        getListData() {
            api.getListData({
                pageNum: this.paginationData.pageNum,
                pageSize: this.paginationData.pageSize,
                unit_id: this.tableId,
                query_user_name: this.searchForm.name,
                query_login_name: this.searchForm.account,
                query_unit_name: this.searchForm.unit
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.paginationData.pageNum = res.bus_json.pageNum;
                    this.paginationData.pageSize = res.bus_json.pageSize;
                    this.paginationData.totalNum = res.bus_json.totalNum;
                    this.treeTableJson = res.bus_json.items;
                }
            });
        },
        //总线获取unit_id，来自tree
        getTableId() {
            Bus.$on("unit_id", (tableId, tableName) => {
                this.tableId = tableId;
                this.tableName = tableName;
            });
        },
        // 分页器公共方法
        paginationDataNew(sth) {
            this.paginationData = sth;
            this.getListData();
        },
        //table增加按钮点击
        addNewOne() {
            if (this.tableId === "1237260078492237824") {
                this.$message({
                    message: "新增业主请前往业主入驻模块进行维护",
                    type: "warning"
                });
                return;
            }
            this.addForm = {
                name: "",
                login_name: "",
                role_ids: "",
                unit: "",
                is_show_logined: "0",
                is_warn_user: "0"
            };
            if (this.tableId) {
                this.addshow = true;
                this.addForm.unit = this.tableName;
            } else {
                this.$message({
                    message: "请选择一个机构",
                    type: "info"
                });
            }
        },
        // 新增提交
        addcommit() {
            this.roleString = [];
            for (let i = 0; i < this.addForm.role_ids.length; i++) {
                this.roleString += this.addForm.role_ids[i] + ";";
            }
            this.roleString = this.roleString.slice(
                0,
                this.roleString.length - 1
            );
            this.$refs["addForm"].validate(valid => {
                if (valid) {
                    if (this.flag) {
                        api.saveUser({
                            user_name: this.addForm.name,
                            login_name: this.addForm.login_name,
                            role_ids: this.roleString,
                            unit: this.addForm.unit,
                            user_id: "",
                            is_show_logined: this.addForm.is_show_logined,
                            is_warn_user: this.addForm.is_warn_user,
                            unit_id: this.tableId
                        }).then(res => {
                            if (res && res.error_code === "0") {
                                this.addshow = false;
                                this.$message({
                                    message: res.error_msg,
                                    type: "success"
                                });
                                this.getListData();
                                setTimeout(() => {
                                    this.flag = true;
                                }, 1500);
                            }
                        });
                    }
                }
            });
        },
        // 获取dialog内角色列表list
        getRoleList_unit() {
            api.getRoleList_unit({}).then(res => {
                if (res && res.error_code === "0") {
                    this.roleJson = res.bus_json;
                }
            });
        },
        // 所有关闭dialog的清除验证的回调
        dialogClose(formName) {
            this.$nextTick(() => {
                this.$refs[formName].resetFields();
            });
        },
        // table内修改按钮点击获取详情
        editNewOne(sth) {
            (this.editForm = {
                name: "",
                login_name: "",
                role_ids: [],
                unit: "",
                user_id: "",
                unit_id: "",
                is_show_logined: "",
                is_warn_user: ""
            }),
                api
                    .getEditUser({
                        unit_id: this.tableId,
                        user_id: sth.user_id
                    })
                    .then(res => {
                        if (res && res.error_code === "0") {
                            for (
                                let i = 0;
                                i < res.bus_json.roles.length;
                                i++
                            ) {
                                this.editForm.role_ids.push(
                                    res.bus_json.roles[i].role_id
                                );
                            }
                            (this.editForm.name = res.bus_json.user_name),
                                (this.editForm.login_name =
                                    res.bus_json.login_name),
                                (this.editForm.unit = res.bus_json.unit_name);
                            this.editForm.unit_id = res.bus_json.unit_id;
                            this.editForm.user_id = res.bus_json.user_id;
                            this.editForm.is_show_logined =
                                res.bus_json.is_show_logined;
                            this.editForm.is_warn_user =
                                res.bus_json.is_warn_user;
                            this.editshow = true;
                        }
                    });
        },
        // 修改dialog保存按钮点击
        editcommit() {
            this.roleString = [];
            for (let i = 0; i < this.editForm.role_ids.length; i++) {
                this.roleString += this.editForm.role_ids[i] + ";";
            }
            this.roleString = this.roleString.slice(
                0,
                this.roleString.length - 1
            );
            this.$refs["editForm"].validate(valid => {
                if (valid) {
                    if (this.flag) {
                        api.saveUser({
                            user_name: this.editForm.name,
                            login_name: this.editForm.login_name,
                            role_ids: this.roleString,
                            unit: this.editForm.unit,
                            user_id: this.editForm.user_id,
                            unit_id: this.editForm.unit_id,
                            is_show_logined: this.editForm.is_show_logined,
                            is_warn_user: this.editForm.is_warn_user
                        }).then(res => {
                            if (res && res.error_code === "0") {
                                this.editshow = false;
                                this.$message({
                                    message: res.error_msg,
                                    type: "success"
                                });
                                this.getListData();
                                setTimeout(() => {
                                    this.flag = true;
                                }, 1500);
                            }
                        });
                    }
                }
            });
        },
        // table内删除按钮点击
        deleteOne(sth) {
            this.$confirm("确认删除该数据？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    api.deleteUser({
                        user_id: sth.user_id
                    }).then(res => {
                        if (res && res.error_code === "0") {
                            this.$message({
                                type: "success",
                                message: res.error_msg
                            });
                            if (
                                this.paginationData.totalNum -
                                    (this.paginationData.pageNum - 1) *
                                        this.paginationData.pageSize ==
                                1
                            ) {
                                this.paginationData.pageNum =
                                    this.paginationData.pageNum == 1
                                        ? this.paginationData.pageNum
                                        : this.paginationData.pageNum - 1;
                            }
                            this.getListData();
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "未删除"
                    });
                });
        },
        // table重置密码点击
        resetOne(sth) {
            this.resetForm = {
                password: "",
                passwordAgain: "",
                user_id: sth.user_id
            };
            if (this.resetForm.user_id) {
                this.resetshow = true;
            }
        },
        // 重置密码按钮提交
        resetPass() {
            if (this.resetForm) {
                if (this.resetForm.password == this.resetForm.passwordAgain) {
                    if (this.flag) {
                        api.resetPass({
                            password: this.resetForm.password,
                            user_id: this.resetForm.user_id
                        }).then(res => {
                            if (res && res.error_code === "0") {
                                this.$message({
                                    type: "success",
                                    message: res.error_msg
                                });
                                this.getListData();
                                this.resetshow = false;
                                setTimeout(() => {
                                    this.flag = true;
                                }, 1500);
                            }
                        });
                    }
                } else {
                    this.$message({
                        type: "info",
                        message: "密码和确认密码不匹配"
                    });
                }
            } else {
                this.$message({
                    type: "info",
                    message: "请输入密码以及确认密码"
                });
            }
        },
        //table内禁用/启用按钮点击
        disableItem(sth) {
            this.disableForm.msg = sth.state == 0 ? "启用" : "禁用";
            this.disableForm.user_id = sth.user_id;
            this.disableForm.state = sth.state;
            this.$confirm(`是否确认${this.disableForm.msg}该用户？`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    api.setState({
                        state: this.disableForm.state == 0 ? 1 : 0,
                        user_id: this.disableForm.user_id
                    }).then(res => {
                        if (res && res.error_code === "0") {
                            this.$message({
                                type: "success",
                                message: res.error_msg
                            });
                            this.getListData();
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `未${this.disableForm.msg}`
                    });
                });
        },
        // 请求codelist接口，获取角色类型
        getRoleTypeList() {
            api.getCodelistByKind({
                code_kind: "user_type"
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.typeJson = res.bus_json[0].codelists;
                }
            });
        }
    },
    created() {},
    mounted() {
        this.getTableId();
        this.getRoleList_unit();
        this.getRoleTypeList();
        this.screenWidth = document.body.clientWidth;
        window.onresize = () => {
            this.screenWidth = document.body.clientWidth;
        };
    },
    // destroyed () {

    // },
    watch: {
        tableId() {
            (this.paginationData = {
                pageNum: "1",
                pageSize: "10",
                totalNum: ""
            }),
                this.getListData();
        },
        screenWidth(val) {
            if (val > 1500) {
                this.screen = true;
            } else if (val < 1500) {
                this.screen = false;
            }
        }
    }
};
</script>
<style lang="scss">
.institutions_table {
    height: 100%;
    padding: 0 30px 0 0;
    box-sizing: border-box;
    .inputCont {
        // width: 100%;
        // display: inline-flex;
        // margin: 0;
        // .demo-form-inline {
        //     width: calc(100% - 200px);
        // }
        width: 100%;
        margin: 15px 0 20px 0;
        .form {
            display: flex;
            justify-content: space-between;
            .el-input__inner {
                height: 36px;
                line-height: 36px;
            }
        }
    }
    .el-table {
        height: 100%;
        overflow-y: auto;
    }
    .el-pager {
        z-index: -1 !important;
        li {
            color: #fff !important;
        }
    }
}
.inputCont .el-form-item label {
    font-size: 16px;
    color: #fff !important;
}
.inputCont .el-form-item__content input {
    border: 1px solid #277ea3;
    color: #fff;
    border-radius: 5px;
    // text-indent:1em;
    background: none;
    &:hover,
    &:focus {
        border: 1px solid #56fbff;
    }
}
.el-dialog__header {
    // background: rgba(24, 97, 214, 0.8)  !important;
    // background: rgba(6, 65, 160, 0.8)  !important;
    .el-dialog__title {
        color: #fff !important;
    }
}
// .el-form-item label {
//     color: rgba(48, 49, 51, 0.6) !important;
// }
.dialog-footer > button {
    font-size: 16px;
    > span {
        line-height: 20px;
    }
}
.oper-icon {
    font-size: 16px !important;
}
</style>
